import { i18n } from '../../../boot/i18n';

export type DAYS = 'MON' | 'TUE' | 'WED' | 'THU' |  'FRI' | 'SAT' | 'SUN';
export const DAYS_LABEL = {
  MON: i18n.t('notificationSessionTypes.daysLabel.MON') as string,
  TUE: i18n.t('notificationSessionTypes.daysLabel.TUE') as string,
  WED: i18n.t('notificationSessionTypes.daysLabel.WED') as string,
  THU: i18n.t('notificationSessionTypes.daysLabel.THU') as string,
  FRI: i18n.t('notificationSessionTypes.daysLabel.FRI') as string,
  SAT: i18n.t('notificationSessionTypes.daysLabel.SAT') as string,
  SUN: i18n.t('notificationSessionTypes.daysLabel.SUN') as string,
}

export type DayNotificationConfig = {
  MON : boolean,
  TUE : boolean,
  WED : boolean,
  THU : boolean,
  FRI : boolean,
  SAT : boolean,
  SUN : boolean,
  time: string,
}

export const DEFAULT_DAYS_NOTIFICATION_CONFIG: DayNotificationConfig = {
  MON : false,
  TUE : false,
  WED : false,
  THU : false,
  FRI : false,
  SAT : false,
  SUN : false,
  time: 'EVENING'
}
